export enum RecordingAction {
  START = "start",
  PAUSE = "pause",
  RESUME = "resume",
  STOP = "stop",
}
